import {configureStore} from '@reduxjs/toolkit';
import {setupListeners} from '@reduxjs/toolkit/query';
import {TypedUseSelectorHook, useSelector} from 'react-redux';
import {fetchGateAPI} from 'app/services/api/fetchGateApi';
import orderReducer from 'app/store/slices/orderSlice';
import rewardReducer from 'app/store/slices/rewardsSlice';
import locationReducer from 'app/store/slices/locationSlice';
import storeReducer from 'app/store/slices/storeSlice';
import {mutateGateAPI} from "app/services/api/mutateGateAPI";
import authReducer from 'app/store/slices/authSlice';
import userReducer from 'app/store/slices/userSlice';
import finalReducer from 'app/store/slices/ConfirmSlice';
import { tReducer, tMiddleware } from '../store';

let toolsFlag = false;
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    // dev code
    toolsFlag = true;
}
export const store = configureStore({
    reducer: {
        // API
        [fetchGateAPI.reducerPath]: fetchGateAPI.reducer,
        [mutateGateAPI.reducerPath]: mutateGateAPI.reducer,

        // Reducers
        rewards: rewardReducer,
        orders: orderReducer,
        location: locationReducer,
        stores: storeReducer,
        auth: authReducer,
        userInfo: userReducer,
        confirmInfo: finalReducer,
        //Toast
        ...tReducer,
    },

    devTools: toolsFlag,

    // Add more middleware to control
    middleware: (getDefaultMiddleware) => getDefaultMiddleware()
        .concat(fetchGateAPI.middleware)
        .concat(mutateGateAPI.middleware)
        .concat(...tMiddleware),
});

// Make state available everywhere
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
setupListeners(store.dispatch);

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
